/** Dev-only error logging, so production consoles stay clean. */
export const logError = (message, error) => {
  if (process.env.NODE_ENV !== "production") {
    console.error(message, error);
  }
};
